import React, { FunctionComponent } from 'react';
import { GuestLoginStep, useGuestLoginI18nNamespace } from '@app/guestLogin/domain/guestLogin';
import { Trans, useTranslation } from 'react-i18next';
import StepsProgress from '@app/components/StepsProgress';
import { isTruthy } from '@app/utils/utils';
import config from '@app/config';
import useTheme from '@app/hooks/useTheme';
import { GuestMode } from '@app/guestLogin/stores/GuestInfraStores';

interface GuestLoginProgressProps {
  step: GuestLoginStep;
  className?: string;
}

const GuestLoginProgress: FunctionComponent<GuestLoginProgressProps> = ({ step, className }) => {
  const { t } = useTranslation();
  const ns = useGuestLoginI18nNamespace();
  const { isHeaderDark } = useTheme<GuestMode>();

  const steps = [
    t(`${ns}.loginProgress.welcome`),
    <Trans i18nKey={`${ns}.loginProgress.emailVerification`}>
      Email
      <br />
      verification
    </Trans>,
    config.shouldLoginWithPhone && (
      <Trans i18nKey={`${ns}.loginProgress.phoneVerification`}>
        Phone
        <br />
        verification
      </Trans>
    ),
    <Trans i18nKey={`${ns}.loginProgress.accountVerification`}>
      Account verification
      <br />
      and details
    </Trans>,
  ].filter(isTruthy);

  return (
    <StepsProgress currentStepIndex={step} showStepNumbering steps={steps} className={className} isHeaderDark={isHeaderDark} />
  );
};

export default GuestLoginProgress;
